import { render, staticRenderFns } from "./ExwarehouseDetail.vue?vue&type=template&id=32f87860&scoped=true"
import script from "./ExwarehouseDetail.vue?vue&type=script&lang=js"
export * from "./ExwarehouseDetail.vue?vue&type=script&lang=js"
import style0 from "./ExwarehouseDetail.vue?vue&type=style&index=0&id=32f87860&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f87860",
  null
  
)

export default component.exports